export default {
  geolocation: {
    lat: '33.9925',
    lng: '7.0125',
    label: '1000 Rabat',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
